// Widget Scripts

import slideshow from './js/widgets/slideshow.js';
import autoEventFeed from './js/widgets/autoEventFeed.js';
import customCards from './js/widgets/customCards.js';
import seoSection from './js/widgets/seo-section/index.js';
import hotButtons from './js/widgets/hotButtons.js';
import cardsBackground from './js/widgets/cardsBackground.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
$(document).ready(function () {
  if (globalThis.location.pathname === '/') {
    slideshow('mainSlideshow', mainSlideshowOpts, 'More');
    slideshow('secondarySlideshow', secondarySlideshowOpts, 'Premium');
    autoEventFeed();
    customCards();
    seoSection();
    hotButtons();
    cardsBackground();
  }
});
